import { map } from 'lodash';

export const amenityOrder = [
  'twentyFourSevenAccess',
  'twentyFourSevenSecurity',
  'barAvailable',
  'barbershop',
  'bikeStorageAvailable',
  'cafeAvailable',
  'carWash',
  'commonAreaWifi',
  'communalLobbySpace',
  'communalOutdoorSpace',
  'communalRoofAccess',
  'conferenceCenter',
  'controlledElevatorAccess',
  'coveredParking',
  'destinationDispatchElevators',
  'electricVehicleChargingStationsCount',
  'expandable',
  'gymAvailable',
  'flexSpaceAvailable',
  'foodServiceAvailable',
  'furnished',
  'generalStoreAvailable',
  'keyCardBuildingEntry',
  'keyCardSpaceEntry',
  'loadingDock',
  'lobbyAttendant',
  'lobbyBeverageAvailable',
  'lobbyFoodAvailable',
  'lockerRooms',
  'messengerCenter',
  'optionToAddInternetServiceProvider',
  'parkingAvailable',
  'parkingGarage',
  'partiallyFurnished',
  'passengerElevatorCount',
  'petsAllowed',
  'pharmacyAvailable',
  'propertyManagerOnSite',
  'privateOutdoorSpace',
  'restaurantAvailable',
  'serviceElevatorCount',
  'sharedPantry',
  'showers',
  'shuttle',
  'spaAvailable',
  'storageAvailable',
  'tenantLounge',
  'tenantPortalApp',
  'touchlessTurnstileEntry',
  'touchFreeElevatorAccess',
  'turnstiles',
  'urgentCareDoctorOnsite',
  'valetParking',
  'yogaStudioAvailable',
];

const isPartiallyFurnished = amenity => {
  return amenity.name === 'furnished' && amenity.value === 'partial';
};

const orderAmenities = (amenityA, amenityB) => {
  // this is a sorta hacky way to accomodate for partially furnished sorting
  const compareA = isPartiallyFurnished(amenityA) ? { name: 'partiallyFurnished' } : amenityA;
  const compareB = isPartiallyFurnished(amenityB) ? { name: 'partiallyFurnished' } : amenityB;

  return amenityOrder.indexOf(compareA.name) - amenityOrder.indexOf(compareB.name);
};

const makeAmenity = (value, name) => {
  if (value === 'no') {
    return { name, value: false };
  }
  return { name, value };
};

export const filterAndOrderAmenities = amenitiesObject => {
  const amenities = map(amenitiesObject, makeAmenity);
  return amenities.filter(amenity => amenity.value).sort(orderAmenities);
};
